import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import InvoiceOnlineBlockData from '../../../Models/Content/InvoiceOnlineBlockData';
import InvoiceOnlineIFrameWrapperComponent from './InvoiceOnlineIFrameWrapperComponent';

export default class InvoiceOnlineBlock extends EpiComponent<InvoiceOnlineBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <InvoiceOnlineIFrameWrapperComponent iContent={this.props.data} context={this.getContext()} />;
  }
}
